import { render, staticRenderFns } from "./travelerData.vue?vue&type=template&id=70026cc7&scoped=true&class=full-height&"
import script from "./travelerData.vue?vue&type=script&lang=js&"
export * from "./travelerData.vue?vue&type=script&lang=js&"
import style0 from "./travelerData.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./travelerData.vue?vue&type=style&index=1&id=70026cc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70026cc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70026cc7')) {
      api.createRecord('70026cc7', component.options)
    } else {
      api.reload('70026cc7', component.options)
    }
    module.hot.accept("./travelerData.vue?vue&type=template&id=70026cc7&scoped=true&class=full-height&", function () {
      api.rerender('70026cc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/travelerData.vue"
export default component.exports